import { useCallback } from 'react';

import { useConfirmDeletedEntry } from './useConfirmDeletedEntry';
import { useSyncStaleEntry } from './useSyncStaleEntry';

import { useInbox } from '../../store/inbox.store';

type useDeletedStaleEntrySubscriberProps = {
  shouldWatchDeletedStaleEntryClicks: boolean;
};

export type DeletedStaleEntrySubscriber = {
  shouldWatchDeletedStaleEntryClicks: boolean;
  onSyncDeletedStaleEntry: (() => Promise<void>) | null;
  ConfirmRefreshDeletedModal: React.FC;
};

export const useDeletedStaleEntrySubscriber = ({
  shouldWatchDeletedStaleEntryClicks,
}: useDeletedStaleEntrySubscriberProps): DeletedStaleEntrySubscriber => {
  const { clearSocket } = useInbox();
  const [ConfirmRefreshDeletedModal, confirmRefreshDeleted] = useConfirmDeletedEntry();
  const syncStaleEntry = useSyncStaleEntry();

  const handleSyncDeletedStaleEntry = useCallback(async () => {
    if (!(await confirmRefreshDeleted())) {
      return;
    }

    // @TODO: check if there will be race condition with clearSocket? add await to syncStaleEntry if necessary
    syncStaleEntry();
    clearSocket();
  }, [syncStaleEntry, clearSocket, confirmRefreshDeleted]);

  return {
    shouldWatchDeletedStaleEntryClicks,
    onSyncDeletedStaleEntry: shouldWatchDeletedStaleEntryClicks
      ? handleSyncDeletedStaleEntry
      : null,
    ConfirmRefreshDeletedModal,
  };
};
